window.addEventListener('scroll', function() {
  var scrollToTopBtn = document.getElementById('scrollToTopBtn');
  if (window.pageYOffset > 100) {
    scrollToTopBtn.classList.add('show');
  } else {
    scrollToTopBtn.classList.remove('show');
  }
});

document.getElementById('scrollToTopBtn').addEventListener('click', function() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});

$j(document).ready(function () {

  /** Move Accessibility-Button Up if needed */

  const presMo = window.matchMedia("screen and (max-width:699px)");
  let isMobile = false;

  function handleSizeChange(e) {
      if (e === null || e === undefined) {
          return;
      }

      if (e.matches) {
          isMobile = true;
      } else {
          isMobile = false;
      }
  }

  if (presMo !== null && presMo !== undefined) {
      presMo.addListener(handleSizeChange);
      handleSizeChange(presMo);
  }

  const observer = new MutationObserver(function (mutationsList, observer) {
      for (const mutation of mutationsList) {
          if (mutation === null || mutation === undefined) {
              continue;
          }

          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              if (mutation.target === null || mutation.target === undefined) {
                  continue;
              }

              if (mutation.target.classList.contains('is-visible')) {
                  handleSizeChange(presMo)
                  if (isMobile) {
                      document.documentElement.style.setProperty('--accessibility-distance', '3rem');
                  }
              } else {
                  document.documentElement.style.setProperty('--accessibility-distance', '0rem');
              }
          }
      }
  });
  const target = document.querySelector('.product-sticky-bar');
  if (target !== null && target !== undefined) {
      observer.observe(target, { attributes: true });
  }
});